import { Typography } from '@mui/material'
import { stripMarkdownFormatting } from '@/utils/stripMarkdownFormatting'

const ChecklistBlock = ({ items }) => {
  if (!items?.length) return null

  const text = items
    .map((item) => {
      const label = stripMarkdownFormatting(item.text)
      return item.checked ? `[x] ${label}` : `[ ] ${label}`
    })
    .join('\n')

  return (
    <Typography
      component="p"
      variant="body2"
      sx={{
        m: 0,
        my: '8px',
        color: 'text.primary',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        lineHeight: 1.6,
        whiteSpace: 'pre-wrap',
      }}
    >
      {text}
    </Typography>
  )
}

export default ChecklistBlock
